let tableSettingsNamespaceHook = (): string | undefined => undefined;

export function useTableSettingsNamespace() {
  return tableSettingsNamespaceHook();
}

export function provideTableSettingsNamespaceHook(hook: typeof tableSettingsNamespaceHook) {
  tableSettingsNamespaceHook = hook;
}
